import type React from "react"

import Typography from "@mui/material/Typography"

interface HighlightedSearchTextProps {
  searchText: string
  text: string
}

export const HighlightedSearchText: React.FC<HighlightedSearchTextProps> = ({
  text,
  searchText,
}) => {
  if (!searchText.trim()) {
    return <Typography component="span">{text}</Typography>
  }

  const escapedSearchText = searchText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(escapedSearchText, "gi")
  const matches = [...text.matchAll(regex)]

  if (matches.length === 0) {
    return <Typography component="span">{text}</Typography>
  }

  const result = []
  let lastIndex = 0

  matches.forEach((match) => {
    const matchStart = match.index ?? 0
    const matchEnd = matchStart + match[0].length

    // Add text before the match
    if (matchStart > lastIndex) {
      result.push(
        <span key={`text-${lastIndex}-${matchStart}`}>
          {text.slice(lastIndex, matchStart)}
        </span>
      )
    }

    // Add the highlighted match
    result.push(
      <em
        key={`match-${matchStart}-${matchEnd}`}
        style={{
          fontWeight: "bold",
          fontStyle: "normal",
        }}
      >
        {match[0]}
      </em>
    )

    lastIndex = matchEnd
  })

  // Add any remaining text after the last match
  if (lastIndex < text.length) {
    result.push(<span key="text-end">{text.slice(lastIndex)}</span>)
  }

  return <Typography component="span">{result}</Typography>
}
